import _ from "lodash";
import React from "react";

import { arrayToIndexedObject } from "@/utils/arrayUtil";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { RATING_OPTION_LABEL_MAP, SCREENING_OPTION_LABEL_MAP } from "@/constants/rating";

import { BehavioralGoalsRating } from "./BehavioralGoalsRating";

export const SUBSTANCE_ABUSE_QUESTIONS = {
  alcohol: {
    answer: null,
    label: "Alcohol Free Days",
  },
  other: {
    answer: null,
    label: "Symptom Free Days",
  },
  substances: {
    answer: null,
    label: "Substance Free Days",
  },
};

const NumberRating = (props) => {
  const { dimensions, isEditing, max, onClick, progress } = props;

  let actualDimensions = dimensions ? dimensions : 30;

  return (
    <div className="col-12 d-flex justify-content-around">
      {Array(max)
        .fill()
        .map((_, optionId) => {
          optionId = parseInt(optionId);
          let optionsClasses = "RatingOption";

          if (progress.answer !== null && progress.answer === optionId) {
            optionsClasses += " RatingOption-active text-white";
          }

          return (
            <div key={optionId} style={{ color: "#F3F4F5", margin: "0px 1px" }}>
              <button
                className={optionsClasses}
                disabled={!isEditing}
                id={`${optionId}`}
                onClick={onClick}
                style={{ height: actualDimensions, width: actualDimensions }}
                type="button"
                value={optionId}
              >
                {optionId}
              </button>
            </div>
          );
        })}
    </div>
  );
};

export const BehavioralSymptomTrend = (props) => {
  let {
    editable,
    editHandler,
    note,
    patientAnswersEditable,
    profileView,
    showProvider,
    smallerDimensions,
  } = props;

  if (!editable) {
    patientAnswersEditable = false;
  }

  let dimensions = 30;

  if (smallerDimensions) {
    dimensions = 15;
  }

  let symptomTrends = _.get(note, "content.symptom_trends", {});
  let symptomTrendsSubstances = _.get(note, "content.symptom_trends_substances", []);

  const handleEditCopyChange = (e, index, key, isNumber = false) => {
    let editCopyClone = _.cloneDeep(symptomTrends);

    editCopyClone[index][key] = isNumber ? parseInt(e.target.value) : e.target.value;

    if (editHandler) {
      editHandler("symptom_trends", editCopyClone);
    }
  };

  const handleSubstancesEditCopyChange = (e, index, key, isCheckbox = false) => {
    if (!editable) {
      return;
    }

    let editCopyClone = _.cloneDeep(symptomTrendsSubstances);

    if (isCheckbox) {
      editCopyClone[index][key] = null;
    } else {
      editCopyClone[index][key] = parseInt(e.target.value);
    }

    if (editHandler) {
      editHandler("symptom_trends_substances", editCopyClone);
    }
  };

  let patientAnswerContent = (
    <>
      <div className="row">
        <div className="col-12">
          <p className="clr-sec tw:font-bold">
            Symptom Trend{" "}
            {showProvider && (
              <span className="clr-pris">
                {" "}
                - {note.signature} {note.session_date}
              </span>
            )}
          </p>
        </div>
      </div>

      {Object.entries(symptomTrends)
        .sort((a, b) => (a[1].order && b[1].order ? a[1].order - b[1].order : 0))
        .map(([key, value]) => {
          let labelOptions;

          if (value.rating_labels) {
            labelOptions = arrayToIndexedObject(value.rating_labels);
          } else {
            labelOptions =
              value.type == null || value.type === "rating"
                ? RATING_OPTION_LABEL_MAP
                : SCREENING_OPTION_LABEL_MAP;
          }

          return (
            <div key={key}>
              <p className="fs-12 tw:font-bold">{value.label}</p>
              <div className="d-flex justify-content-start">
                {Object.values(labelOptions).map((optionLabel) => (
                  <div className="w-25 fs-10 text-center tw:font-bold">
                    <div className="m-auto">{optionLabel}</div>
                  </div>
                ))}
              </div>

              <div>
                <BehavioralGoalsRating
                  containerClass="p-0"
                  isEditing={patientAnswersEditable}
                  onClick={(e) => handleEditCopyChange(e, key, "answer", true)}
                  optionLabelMap={labelOptions}
                  optionsClasses={!profileView ? "RatingOption-bg-white" : ""}
                  progress={value}
                />
              </div>
            </div>
          );
        })}
    </>
  );

  let providerAnswerContent = (
    <>
      {showProvider && (
        <span className="clr-sec tw:font-bold">
          {" "}
          {note.signature} {note.session_date}
        </span>
      )}

      {Object.entries(symptomTrendsSubstances).map(([key, value]) => {
        return (
          <div className="row fs-12" key={key}>
            <div className="col-lg-3">
              <p className="mb-0 tw:font-bold">{value.label}</p>
              <label>
                <input
                  checked={value.answer == null}
                  className="custom-checkbox"
                  onClick={(e) => handleSubstancesEditCopyChange(e, key, "answer", true)}
                  type="checkbox"
                />
                <span className="ml-1">non/applicable</span>
              </label>
            </div>

            <div className="col-lg-2 float-right">
              <p>0 - 7 days</p>
            </div>

            <div className="col-lg-7 d-flex justify-content-start">
              <NumberRating
                dimensions={dimensions}
                isEditing={editable}
                max={8}
                onClick={(e) => handleSubstancesEditCopyChange(e, key, "answer")}
                progress={value}
              />
            </div>
          </div>
        );
      })}
    </>
  );

  let desktopContent;

  if (!profileView) {
    let providerCss = "mx-0 px-3 py-3 my-3 w-100 max-width d-none d-md-none d-lg-block ";

    if (showProvider) {
      providerCss += "grey-container";
    }
    desktopContent = (
      <>
        <CardSecondary className="mx-0 px-3 py-3 my-3 w-100 max-width d-none d-md-none d-lg-block grey-container">
          {patientAnswerContent}
        </CardSecondary>
        <CardSecondary className={providerCss}>{providerAnswerContent}</CardSecondary>
      </>
    );
  } else {
    desktopContent = (
      <div className="d-none d-md-none d-lg-block">
        {patientAnswerContent}
        {providerAnswerContent}
      </div>
    );
  }

  let mobileContent = (
    <CardSecondary className="mx-auto d-block d-md-block d-lg-none mt-3">
      <div className={!profileView ? "grey-container" : ""}>{patientAnswerContent}</div>

      {Object.entries(symptomTrendsSubstances).map(([key, value]) => {
        return (
          <React.Fragment key={key}>
            <p className="fs-12 tw:font-bold">{value.label}</p>
            <div>
              <div className="float-left">
                <input
                  checked={value.answer == null}
                  onClick={(e) => handleSubstancesEditCopyChange(e, key, "answer", true)}
                  type="checkbox"
                />
                <label>non/applicable</label>
              </div>

              <div className="float-right">
                <p>0 - 7 days</p>
              </div>
            </div>

            <NumberRating
              dimensions={dimensions}
              isEditing={editable}
              max={8}
              onClick={(e) => handleSubstancesEditCopyChange(e, key, "answer")}
              progress={value}
            />
          </React.Fragment>
        );
      })}
    </CardSecondary>
  );

  return (
    <>
      {desktopContent}
      {mobileContent}
    </>
  );
};
